import App from './App.vue'
import i18n from '@/i18n'
import router from './router'
import store from './store'
import '@/assets/fonts/helvetica-neue.css'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCarousel from 'vue-carousel'
import { ObserveVisibility } from 'vue-observe-visibility'
import Scn from '@/components/scn'
import SectionHeader from '@/components/section-header'
import VueAnalytics from 'vue-analytics'

import {
  faPlus,
  faMinus,
  faChevronRight,
  faCommentAlt,
  faHeart,
  faShareSquare,
  faChevronDown,
  faBars,
  faTimes,
  faQuoteLeft,
  faQuoteRight,
  faGlobe,
  faArrowLeft,
  faFilePdf
} from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faLinkedinIn, faYoutube, faYelp, faWhatsapp, faXTwitter } from '@fortawesome/free-brands-svg-icons'

library.add(
  faPlus, faMinus, faChevronRight, faFacebookSquare, faLinkedinIn,
  faYoutube, faYelp, faCommentAlt, faHeart, faShareSquare, faWhatsapp,
  faChevronDown, faBars, faTimes, faQuoteLeft, faQuoteRight, faGlobe, faArrowLeft, faFilePdf, faXTwitter
)

Vue.use(VueI18n)
Vue.use(VueCarousel)
Vue.use(VueAnalytics, {
  id: 'UA-149151325-1',
  router
})
Vue.directive('observe-visibility', ObserveVisibility)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('scn', Scn)
Vue.component('section-header', SectionHeader)

Vue.config.productionTip = false

Vue.prototype.$getImage = (image) => require(`@/assets/images/${image}`)

new Vue({
  i18n,
  router,
  store,
  render: (hh) => hh(App)
}).$mount('#app')
